var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('create_campaign.successfully_saved')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }